import React, { useState } from 'react';
import { useLanguage } from './LanguageContext';

const linkStyle = {
  color: '#fff',
  textDecoration: 'none',
  margin: '0 8px',
  cursor: 'pointer',
  transition: 'color 0.3s'
};

const linkHoverStyle = {
  color: '#d9bf84'
};

const textos = {
  es: {
    aviso: 'AVISO LEGAL',
    privacidad: 'POLÍTICA DE PRIVACIDAD',
    avisoTitulo: 'Aviso Legal',
    avisoContenido: [
      'Este sitio web es propiedad de Jiǎo Yǒu Xǐ.',
      'Su propósito es exclusivamente informativo para dar a conocer los platos ofrecidos por el restaurante.',
      'No se realiza actividad comercial online ni se recogen datos personales.',
      'Los precios de la carta pueden variar y son orientativos.',
      'Las imágenes de los platos mostradas en este sitio web son ilustrativas. El producto final servido en el restaurante puede diferir en presentación, cantidad o ingredientes.',
      'Todos los contenidos, imágenes y textos tienen derechos reservados.'
    ],
    privacidadTitulo: 'Política de Privacidad',
    privacidadContenido: 'Esta web utiliza cookies técnicas necesarias para su correcto funcionamiento, como la integración de mapas de Google. No utilizamos cookies de seguimiento ni recopilamos datos personales.',
    cerrar: 'Aceptar',
    disenadoPor: 'Diseñado por Jiǎo Yǒu Xǐ. Todos los derechos reservados.'
  },
  en: {
    aviso: 'LEGAL NOTICE',
    privacidad: 'PRIVACY POLICY',
    avisoTitulo: 'Legal Notice',
    avisoContenido: [
      "This website is owned by Jiǎo Yǒu Xǐ.",
      "Its sole purpose is to provide information about the restaurant's menu.",
      "No online sales or data collection is performed.",
      "The pictures are for reference only, and the actual product shall prevail.",
      "All content, images, and text are protected by copyright."
    ],
    privacidadTitulo: 'Privacy Policy',
    privacidadContenido: 'This website uses technical cookies necessary for its proper functioning, such as Google Maps integration. We do not use tracking cookies or collect personal data.',
    cerrar: 'Accept',
    disenadoPor: 'Designed by Jiǎo Yǒu Xǐ. All rights reserved.'
  },
  zh: {
    aviso: '法律声明',
    privacidad: '隐私政策',
    avisoTitulo: '法律声明',
    avisoContenido: [
      '本网站由 Jiǎo Yǒu Xǐ 拥有。',
      '仅用于介绍餐厅菜单信息。',
      '不进行在线销售或收集用户数据。',
      '图片仅供参考，出品以实物为准。',
      '所有内容、图片和文字均受版权保护。'
    ],
    privacidadTitulo: '隐私政策',
    privacidadContenido: '本网站使用为正确运行所必需的技术性 cookie，例如集成谷歌地图。我们不使用跟踪 cookie，也不收集个人数据。',
    cerrar: '接受',
    disenadoPor: '由 Jiǎo Yǒu Xǐ 设计。保留所有权利。'
  }
};

function Footer() {
  const [showPopup, setShowPopup] = useState(false);
  const [popupType, setPopupType] = useState(null);
  const [hovered, setHovered] = useState(null);
  const { language } = useLanguage();
  const t = textos[language];

  const handlePopupClick = (type) => {
    setPopupType(type);
    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
    setPopupType(null);
  };

  const currentTitle = popupType === 'aviso' ? t.avisoTitulo : t.privacidadTitulo;
  const currentContent = popupType === 'aviso' ? t.avisoContenido : t.privacidadContenido;

  return (
    <footer style={{
      backgroundColor: '#1f1f1f',
      color: '#fff',
      padding: '20px',
      textAlign: 'center',
      fontSize: '14px',
      borderTop: '1px solid #d9bf84',
      position: 'relative'
    }}>
      <div style={{ marginBottom: '12px' }}>
        <span
          onClick={() => handlePopupClick('aviso')}
          onMouseEnter={() => setHovered('aviso')}
          onMouseLeave={() => setHovered(null)}
          style={{ ...linkStyle, ...(hovered === 'aviso' ? linkHoverStyle : {}), fontWeight: 'bold' }}
        >
          {t.aviso}
        </span>
        &nbsp;|&nbsp;
        <span
          onClick={() => handlePopupClick('privacidad')}
          onMouseEnter={() => setHovered('privacidad')}
          onMouseLeave={() => setHovered(null)}
          style={{ ...linkStyle, ...(hovered === 'privacidad' ? linkHoverStyle : {}), fontWeight: 'bold' }}
        >
          {t.privacidad}
        </span>
      </div>
      <div style={{ color: '#d9bf84', fontWeight: 'bold' }}>
        {t.disenadoPor}
      </div>

      {showPopup && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: '#1f1f1f',
            border: '2px solid #d9bf84',
            borderRadius: '8px',
            padding: '24px',
            maxWidth: '500px',
            color: '#fff',
            textAlign: 'left',
            boxShadow: '0 0 12px rgba(0,0,0,0.5)'
          }}>
            <h2 style={{ color: '#d9bf84', marginBottom: '12px' }}>{currentTitle}</h2>
            {Array.isArray(currentContent) ? (
              <ul style={{ paddingLeft: '20px', fontSize: '16px', lineHeight: '1.6' }}>
                {currentContent.map((line, index) => (
                  <li key={index}>{line}</li>
                ))}
              </ul>
            ) : (
              <p style={{ fontSize: '16px', lineHeight: '1.5' }}>{currentContent}</p>
            )}
            <button onClick={handleClosePopup} style={{
              marginTop: '16px',
              background: 'linear-gradient(135deg, #f2cf73, #b8892f)',
              border: 'none',
              padding: '10px 20px',
              color: '#17120d',
              borderRadius: '6px',
              cursor: 'pointer',
              fontWeight: 'bold'
            }}>
              {t.cerrar}
            </button>
          </div>
        </div>
      )}
    </footer>
  );
}

export default Footer;
